<script setup lang="ts">
const { isWithinMigrationPeriod } = useFeatureFlagsNew();

const { openSupportChat, hasLiveSupport } = useLiveSupport();

const isSupportButtonVisible = computed(() => {
  return hasLiveSupport.value && isWithinMigrationPeriod.value && !isBetBr();
});
</script>

<template>
  <button
    v-if="isSupportButtonVisible"
    :class="$style.supportButton"
    @click="openSupportChat"
  >
    <NuxtIcon
      :class="$style.icon"
      name="messages"
    />
    <span>{{ $t('sidebar.live_support') }}</span>
  </button>
</template>

<style module lang="postcss">
.supportButton {
  @apply bg-button-bg text-button-text px-4 py-2 rounded-full fixed bottom-8 right-8 z-[999] font-bold text-sm flex items-center justify-center gap-2;

  .icon {
    @apply text-xl;
  }
}
</style>
